import React, { Component } from 'react'

class ChannelList extends Component {

    static propTypes = {
        selectChannel: React.PropTypes.func.isRequired,
        channels: React.PropTypes.object,
        selectedChannelId: React.PropTypes.number,
    }

    render() {
        return (<div className="channels">
                    {this.props.channels.map((channel) => 
                        <div className="row" onClick={() => this.props.selectChannel(channel.Id)}>
                            {this.props.selectedChannelId === channel.Id ? <b>{channel.Name}</b> : channel.Name  }
                        </div>
                    )}
                </div>)
    }
}

export default ChannelList



/** WEBPACK FOOTER **
 ** ./src/components/PopupStats/ChatComponents/ChannelList.js
 **/